import React, { Component } from "react";
import { func } from "prop-types";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import copy from "clipboard-copy";
import { notify } from "react-notify-toast";
import pathToRegex from "path-to-regexp";
import {
  ROUTE_PRIORITIZE_EDIT,
  ROUTE_PRIORITIZE_EDIT_FACTORS,
} from "src/Routes";
import { GLOBAL_PATH_PREFIX } from "src/constants";
import Tabs from "src/components/shared/Tabs";
import { ReactComponent as EditIcon } from "src/images/edit2.svg";
import { ReactComponent as ShareLinkIcon } from "src/images/share-link.svg";
import { ReactComponent as ExportIcon } from "src/images/export-csv.svg";
import { Button, DialogModalWindow, Tooltip } from "src/components/shared";
import collectionApi from "src/api/v2/CollectionApi";
import { TrackingAnalytics } from 'src/analytics/TrackingAnalytics';
import { convertToCSV } from 'src/util/utils';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShareDialogOpen: false,
    };
  }

  onClick = (id) => {
    if (id === "result") {
      this.onResultClick();
    } else {
      this.onParticipateClick();
    }
  };

  getParticipateURL = () => {
    const pathArray = window.location.pathname.split("/");
    const id = pathArray && pathArray.length > 3 ? pathArray[3] : "";
    return `${GLOBAL_PATH_PREFIX}/p/${id}`;
  };

  getShareURL = () => {
    return window.location.origin + this.getParticipateURL();
  };

  onParticipateClick = () => {
    // TODO: Need to refactor to use routing logic for performance
    this.props.history.push(this.getParticipateURL());
  };

  onResultClick = () => {
    // TODO: Need to refactor to use routing logic for performance
    this.props.history.push(`${this.getParticipateURL()}/result`);
  };

  onShareUrlClick = () => {
    TrackingAnalytics.send(`Prioritize - Share`);
    copy(this.getShareURL())
      .then(() => {
        notify.show("Copied share link to clipboard!", "success", 1000);
      })
      .catch(() => {
        notify.show("Failed to copy share link to clipboard!", "warning", 1000);
      });
  };

  onExportClick = async () => {
    TrackingAnalytics.send(`Prioritize - Export CSV`);
    const pathArray = window.location.pathname.split("/");
    const id = pathArray && pathArray.length > 3 ? pathArray[3] : "";
    const responses = await collectionApi.getResponses(id);
    const csv = convertToCSV(responses);
    const hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
    hiddenElement.target = "_blank";
    hiddenElement.download = `prioritize-export-${id}.csv`;
    hiddenElement.click();
  };

  onEditClick = () => {
    // TODO: Need to refactor to use routing logic for performance
    this.props.history.push(`${this.getParticipateURL()}/edit`);
  };

  isOnEditPage = () => {
    const routes = [ROUTE_PRIORITIZE_EDIT, ROUTE_PRIORITIZE_EDIT_FACTORS];
    const { location } = this.props;

    for (let idx = 0; idx < routes.length; idx++) {
      const fullPath = `${GLOBAL_PATH_PREFIX}/${routes[idx]}`;
      const regex = pathToRegex(fullPath);

      if (regex.exec(location.pathname)) {
        return true;
      }
    }

    return false;
  };

  render() {
    const { isShareDialogOpen } = this.state;
    const { collection, currentTabIdx } = this.props;
    const isCreator = _.get(collection, "owner.current_user", false);
    const TABS = [
      { id: "participate", title: "PARTICIPATE" },
      { id: "result", title: "RESULTS" },
    ];

    const isNavHidden = this.isOnEditPage();
    if (isNavHidden) return null;

    return (
      <div className="prioritize-navbar_container">
        {isCreator && (
          <div className="container prioritize-navbar">
            <div className="prioritize-navbar__tabs_cont">
              <Tabs
                tabs={TABS}
                availableTabs={TABS.length}
                onClick={this.onClick}
                currentTabIdx={currentTabIdx}
              />
            </div>
            <div className="prioritize-navbar__icons">
              <Button
                className="btn-menu"
                onClick={() => this.setState({ isShareDialogOpen: true })}
              >
                <Tooltip
                  tooltip="Share this Prioritize POPin with others"
                  placement="bottom"
                >
                  <ShareLinkIcon width="20" height="20" />
                </Tooltip>
              </Button>
              <Button className="btn-menu" onClick={this.onExportClick}>
                <Tooltip tooltip="Export results to CSV" placement="bottom">
                  <ExportIcon width="20" height="20" />
                </Tooltip>
              </Button>
              <Button className="btn-menu" onClick={this.onEditClick}>
                <Tooltip tooltip="Edit this POPin" placement="bottom">
                  <EditIcon width="20" height="20" />
                </Tooltip>
              </Button>
            </div>
          </div>
        )}
        <DialogModalWindow
          isOpen={isShareDialogOpen}
          title={"Copy and share this link to spread the word"}
          onCancel={() => this.setState({ isShareDialogOpen: false })}
          cancelBtn={false}
          confirmBtn={false}
        >
          <div className="share">
            <div className="url" onClick={this.onShareUrlClick}>
              {this.getShareURL()}
            </div>
            <Button className="btn-primary" onClick={this.onShareUrlClick}>
              Copy
            </Button>
          </div>
          <small>
            Anyone inside and/or outside your organization can access your POPin
            with this link
          </small>
        </DialogModalWindow>
      </div>
    );
  }
}

Navbar.propTypes = {
  onClick: func,
};

Navbar.defaultProps = {
  onClick: () => {},
};

export default withRouter(Navbar);
